import { render, staticRenderFns } from "./questionnaire2021.vue?vue&type=template&id=e6890f84&scoped=true&"
import script from "./questionnaire2021.vue?vue&type=script&lang=js&"
export * from "./questionnaire2021.vue?vue&type=script&lang=js&"
import style0 from "./questionnaire2021.vue?vue&type=style&index=0&id=e6890f84&prod&lang=less&scoped=true&"
import style1 from "./questionnaire2021.vue?vue&type=style&index=1&id=e6890f84&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6890f84",
  null
  
)

export default component.exports